import { TLead } from "types/lead.type";
import { BaseApi } from "./base.api";

export class LeadIovoxCallerApi extends BaseApi {
  async makeIovoxCall(accountId: number, leadId: number): Promise<TLead> {
    return this.post(`/accounts/${accountId}/leads/${leadId}/iovox`);
  }
}
